import { StrictMode } from "react";
import ReactDOM from "react-dom";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { RouterProvider } from "@tanstack/react-router";

import "./bootstrap";
import { queryClient } from "./config/query-client";
import { router } from "./config/router";
import { initializeSentry } from "./config/sentry";
import { env } from "./env";
import { Toasts } from "./ui";

import "../css/app.css";

initializeSentry();

createRoot(document.getElementById("app")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <Sentry.ErrorBoundary>
        <RouterProvider router={router} />
      </Sentry.ErrorBoundary>

      {ReactDOM.createPortal(<Toasts />, document.body)}

      {env.VITE_APP_ENV === "local" && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  </StrictMode>,
);
